import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class FrameDetectionService {
  private readonly isInIframe: boolean

  constructor() {
    // Check if current window is different from its parent window (i.e., inside iframe)
    // Added try-catch to handle possible cross-origin access errors
    try {
      this.isInIframe = window !== window.parent
    } catch {
      // If cross-origin error occurs, assume we're in an iframe
      this.isInIframe = true
    }
  }

  public isIframe(): boolean {
    return this.isInIframe
  }
}
